import { EyeIcon, EyeSlashIcon, KeyIcon } from '@heroicons/react/24/outline';
import { Button, Input } from '@nextui-org/react';
import React from 'react';

import { ModernModal } from '@portal/components/common/ModernModal.ui';

interface ChangePasswordModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  passwordData: {
    password: string;
    confirmPassword: string;
  };
  onPasswordDataChange: (data: { password: string; confirmPassword: string }) => void;
  showNewPassword: boolean;
  showConfirmPassword: boolean;
  onShowNewPasswordChange: (show: boolean) => void;
  onShowConfirmPasswordChange: (show: boolean) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

export const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  isOpen,
  onOpenChange,
  passwordData,
  onPasswordDataChange,
  showNewPassword,
  showConfirmPassword,
  onShowNewPasswordChange,
  onShowConfirmPasswordChange,
  onSubmit,
  isLoading,
}) => {
  const icon = <KeyIcon className='h-4 w-4' />;

  const footer = (
    <>
      <Button color='danger' variant='light' onPress={onOpenChange} disabled={isLoading}>
        Cancel
      </Button>
      <Button color='primary' onPress={onSubmit} isLoading={isLoading}>
        Update Password
      </Button>
    </>
  );

  return (
    <ModernModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title='Change Password'
      subtitle='Update user password'
      icon={icon}
      size='md'
      footer={footer}
    >
      <div className='flex flex-col gap-4'>
        <Input
          label='New Password'
          placeholder='Enter new password'
          type={showNewPassword ? 'text' : 'password'}
          value={passwordData.password}
          onValueChange={value => onPasswordDataChange({ ...passwordData, password: value })}
          endContent={
            <button
              className='focus:outline-none'
              type='button'
              onClick={() => onShowNewPasswordChange(!showNewPassword)}
            >
              {showNewPassword ? (
                <EyeSlashIcon className='h-4 w-4 text-gray-400' />
              ) : (
                <EyeIcon className='h-4 w-4 text-gray-400' />
              )}
            </button>
          }
          isRequired
        />
        <Input
          label='Confirm Password'
          placeholder='Confirm new password'
          type={showConfirmPassword ? 'text' : 'password'}
          value={passwordData.confirmPassword}
          onValueChange={value => onPasswordDataChange({ ...passwordData, confirmPassword: value })}
          endContent={
            <button
              className='focus:outline-none'
              type='button'
              onClick={() => onShowConfirmPasswordChange(!showConfirmPassword)}
            >
              {showConfirmPassword ? (
                <EyeSlashIcon className='h-4 w-4 text-gray-400' />
              ) : (
                <EyeIcon className='h-4 w-4 text-gray-400' />
              )}
            </button>
          }
          isRequired
        />
      </div>
    </ModernModal>
  );
};
